import React, { useContext, useEffect, useRef, useState } from 'react';
import SetUpAccount from '../../Components/SetUpAccount';
import SSLogo from '../../Components/SSLogo';
import { getParameterByName, isEmpty, shutdownIntercom } from '../../utils';
import BGImage from '../../assets/bg-blur.png';
import { getSessionStorage, removeSessionStorage } from '../../utils';

import './homepage.scss';
import NavBar from '../../Components/NavBar';
import SSHomePage from '../../Components/SSHomePage';
import { CurrentUserDetails } from '../../context';
import { Redirect, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { trackEvents } from '../../utils/analytics';

export default function HomePage() {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const isUserSetup = JSON.parse(localStorage.getItem('ss-user-setup')) || false;
  const [profile, profileDispatch] = useContext(CurrentUserDetails);
  const invitedUserToken = getParameterByName('userToken');
  let isStatusExpired = getParameterByName('status');
  const paymentStatus = getParameterByName('payment_status');
  const accountType = getParameterByName('accountType');
  const currentTab = getParameterByName('tab');
  const authTokenFromApp = getParameterByName('accessToken');
  const isAppRedirect = getParameterByName('appRedirect');
  const history = useHistory();
  const trainingRef = useRef(null);
  const salesStackRef = useRef(null);

  let productInfo = getSessionStorage('product-info') || {};

  useEffect(() => {
    if (authTokenFromApp) {
      if (currentTab === 'ai-training') {
        trainingRef.current = true;
      } else if (currentTab === 'sales-stack-app') {
        salesStackRef.current = true;
      }
    }
    if (paymentStatus === 'success') {
      if (Object.keys(productInfo).length > 0) {
        trackEvents('purchase', {
          ...productInfo,
        });
        // GTM event
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: 'purchase',
          user_id: profile.userId,
          type: accountType?.toLowerCase() === 'individual' ? 'individual' : 'team_member',
          ecommerce: {
            currency: productInfo.currency,
            value: productInfo.value,
            items: [
              {
                item_id: productInfo.items.item_id,
                item_name: productInfo.items.item_name,
                price: productInfo.items.price,
                discount: 0.0,
                quantity: 1,
              },
            ],
          },
        });

        productInfo = {};
        removeSessionStorage('product-info');
      }
      toast.success('Payment success!', {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }

    // removing toast for failed payment -
    // if (paymentStatus === 'failed') {
    //   // setIsPaymentScreen(true);
    //   history.replace({
    //     search: '',
    //   });
    //   toast.error('Your payment failed', {
    //     position: 'top-center',
    //     autoClose: 2000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     progress: undefined,
    //   });
    // }

    if (isAppRedirect) {
      window.location.href = `salesstack://open=%s?paymentStatus=${paymentStatus}`;
      window.history.pushState({}, document.title, window.location.pathname);
    }

    if (isEmpty(userToken)) {
      shutdownIntercom();
      window.location = '/signin';
    }
  }, []);

  if (authTokenFromApp) {
    localStorage.setItem('ss-auth-sales', JSON.stringify({ accessToken: authTokenFromApp }));
    localStorage.setItem('ss-user-setup', true);
    return <Redirect to="/" />;
  }

  if (isStatusExpired === 'expired') {
    history.replace({
      search: '',
    });
    toast.error('Your invite has expired', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
    redirectToSign();
  }

  if (invitedUserToken) {
    localStorage.setItem('ss-auth-sales', JSON.stringify({ accessToken: invitedUserToken }));
    return <Redirect to="/" />;
  }
  const redirectToSign = () => {
    shutdownIntercom();
    window.location = '/signin';
  };

  return (
    <div className="ss-homepage">
      {!isEmpty(userToken) ? (
        <div className="ss-homepage-navbar">
          <a className="stack-logo">
            <SSLogo salesStackRef={salesStackRef} />
          </a>
          <NavBar />
        </div>
      ) : (
        <div className="stack-logo">
          <SSLogo />
        </div>
      )}

      {isEmpty(userToken) ? (
        <div>
          <div
            className="center-div bg"
            style={{
              backgroundImage: `url(${BGImage})`,
            }}
          ></div>
          <div className="setup-home">{/* <SetUpAccount /> */}</div>
        </div>
      ) : (
        <div>
          <SSHomePage trainingRef={trainingRef} salesStackRef={salesStackRef} />
        </div>
      )}
    </div>
  );
}
